import { Modal } from 'antd';
import React, { Component } from 'react';


export class HisenseInvalidEvaluation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            tenantId: null,
            commonParamater: null
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater });
        this.setState({ tenantId: tenantId });
    }

    render() {
        return (
            <div style={{ margin: "32px auto", maxWidth: "1000px" }}>
                <div>
                    <Modal title="作废测评" visible={this.state.visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                        <p>确定作废测评？</p>
                    </Modal>
                </div>
            </div>)
    }
    handleOk = values => {
        const commonParamater = this.state.commonParamater;
        const tenantId = this.state.tenantId;
        window.location.href = "/hisense_invalid_success?commonParamater=" + commonParamater + "&tenantId=" + tenantId;
    }
    handleCancel = (e) => {
        this.setState({ visible: false });
    }
}